<div class="container-modal-lateral">
  <div>
    <span class="title-modal-lateral">Filtrar</span>
    <div class="filtro">
      <app-select-one
        class="width-100"
        heightFormField="36px"
        placeholder="Selecione o status"
        [listaInput]="statusOpcoes"
        [itemSelecionado]="filtro.status"
        (selecionarItem)="filtro.status = $event"
        label="Status"
        campo="nome"
      ></app-select-one>
      <app-select-one
        class="width-100"
        heightFormField="36px"
        placeholder="Selecione o setor"
        [listaInput]="setores"
        [itemSelecionado]="filtro.setor"
        (selecionarItem)="filtro.setor = $event"
        label="Setor"
        campo="nome"
      ></app-select-one>
      <app-select-one
        class="width-100"
        heightFormField="36px"
        placeholder="Selecione o perfil"
        [listaInput]="perfis"
        [itemSelecionado]="filtro.perfil"
        (selecionarItem)="filtro.perfil = $event"
        label="Perfil"
        campo="nome"
      ></app-select-one>
    </div>
  </div>

  <div class="botoes-modal-lateral">
    <app-button-padrao
      width="100%"
      label="Filtrar"
      backgroundColor="var(--verde-padrao)"
      color="white"
      (buttonClick)="filtrar()">
    </app-button-padrao>
    <app-button-padrao
      width="100%"
      label="Cancelar"
      backgroundColor="white"
      color="var(--vermelho-padrao)"
      (buttonClick)="cancelar()"
      borderColor="var(--vermelho-padrao)"
      borderStyle="solid"
      borderWidth="1px">
    </app-button-padrao>
  </div>
</div>
